import { render, staticRenderFns } from "./OngletSynthesePrestation.vue?vue&type=template&id=3fcd5f9d"
import script from "./OngletSynthesePrestation.vue?vue&type=script&lang=js"
export * from "./OngletSynthesePrestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports